import classNames from "classnames";
import PropTypes from "prop-types";
import { MdGroups, MdPerson } from "react-icons/md";
import { PROJECTS_SCOPE } from "utils/constants";

const ScopeToggle = ({
  scope,
  onChange,
  mineLabel,
  allLabel,
  mineCount,
  allCount,
}) => (
  <div className="projects-scope-toggle">
    <button
      type="button"
      className={classNames("projects-scope-toggle__btn", {
        "projects-scope-toggle__btn--active": scope === PROJECTS_SCOPE.MINE,
      })}
      onClick={() => onChange(PROJECTS_SCOPE.MINE)}
    >
      <MdPerson className="projects-scope-toggle__icon" size={18} />
      <span className="projects-scope-toggle__label">{mineLabel}</span>
      <span className="projects-scope-toggle__count">{mineCount ?? "—"}</span>
    </button>
    <button
      type="button"
      className={classNames("projects-scope-toggle__btn", {
        "projects-scope-toggle__btn--active":
          scope === PROJECTS_SCOPE.ORGANIZATION,
      })}
      onClick={() => onChange(PROJECTS_SCOPE.ORGANIZATION)}
    >
      <MdGroups className="projects-scope-toggle__icon" size={18} />
      <span className="projects-scope-toggle__label">{allLabel}</span>
      <span className="projects-scope-toggle__count">{allCount ?? "—"}</span>
    </button>
  </div>
);

ScopeToggle.propTypes = {
  scope: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  mineLabel: PropTypes.string.isRequired,
  allLabel: PropTypes.string.isRequired,
  mineCount: PropTypes.number,
  allCount: PropTypes.number,
};

ScopeToggle.defaultProps = {
  mineCount: null,
  allCount: null,
};

export default ScopeToggle;
